import { Loading as LoadingTemplate } from '@/plugins/rpg/client';
export const Loading = () => {
  return <LoadingTemplate spinClassName='fill-secondary' titleText='กำลังโหลดข้อมูล..' descriptionText='หากนานเกิน 10 วินาที กรุณารีเฟรช' containerClassName='bg-primary' />;
};